export default class SkipNewReturnInspectionRequest
{
    public externalDeviceId : string = "";

    public comment : string = "";

    public resetStatus: boolean = false;
}